/**
 * WhatsApp oficial Bientech (WhatsApp Business) — formato internacional (wa.me).
 * Brasil: 55 + DDD (53) + 9961-1396
 */
export const WHATSAPP_COUNTRY_CODE = '55';
export const WHATSAPP_AREA_CODE = '53';
export const WHATSAPP_MOBILE_NUMBER = '99611396';

/** E.164 sem "+" — ex.: 555399611396 */
export const WHATSAPP_E164 = `${WHATSAPP_COUNTRY_CODE}${WHATSAPP_AREA_CODE}${WHATSAPP_MOBILE_NUMBER}`;

/** Exibição humana: +55 (53) 9961-1396 */
export const WHATSAPP_DISPLAY = `+${WHATSAPP_COUNTRY_CODE} (${WHATSAPP_AREA_CODE}) 9961-1396`;

/**
 * @param {string} [message] Mensagem pré-preenchida
 * @returns {string} URL wa.me
 */
export function buildWhatsAppUrl(message) {
  const base = `https://wa.me/${WHATSAPP_E164}`;
  if (!message || !String(message).trim()) {
    return base;
  }
  return `${base}?text=${encodeURIComponent(message)}`;
}
